import { getAlgoliaResults } from "@algolia/autocomplete-js";
import { useI18n } from "vue-i18n";
import { useLanguages } from "@/core/composables";
import { prefixLocaleUrl } from "@/core/utilities";
import { getIndexName } from "@/shared/thorlabs/search";
import { getCdnUrl } from "@/shared/thorlabs/shared/image-resize";
import { searchClient } from "./searchClient";
import type { IAlgoliaVisNavPage } from "../searchTypes";

export function getGuidesPlugin() {
  const { t } = useI18n();

  const { currentLocale, defaultLocale } = useLanguages();
  const visNavIndexName = getIndexName("visnavs", currentLocale.value);

  return {
    getSources({ query }: { query: string }) {
      if (!query) {
        return [];
      }
      return [
        {
          sourceId: "guides",
          getItems() {
            return getAlgoliaResults({
              searchClient: searchClient.value,
              queries: [
                {
                  indexName: visNavIndexName,
                  params: {
                    query,
                    hitsPerPage: 3,
                    attributesToSnippet: ["name:10"],
                    snippetEllipsisText: "…",
                  },
                },
              ],
            });
          },
          templates: {
            header({
              html,
              items,
            }: {
              html: (literals: TemplateStringsArray, ...placeholders: unknown[]) => string;
              items: IAlgoliaVisNavPage[];
            }) {
              if (items.length === 3) {
                return html`<h6>${t("autocomplete.search.top_3_guides")}</h6>`;
              } else {
                return html`<h6>${t("autocomplete.search.top_guides")}</h6>`;
              }
            },
            item({
              item,
              html,
            }: {
              html: (literals: TemplateStringsArray, ...placeholders: unknown[]) => string;
              item: IAlgoliaVisNavPage;
            }) {
              return html`
                <a
                  href="${prefixLocaleUrl(item.url, currentLocale.value, defaultLocale.value)}"
                  class="guide-match--item"
                  onClick=${() => {
                    const event = new CustomEvent("closeSearchDropdown");
                    document.dispatchEvent(event);
                  }}
                >
                  <div class="guide-match--content">
                    <span dangerouslySetInnerHTML=${{ __html: item.title }}></span>
                  </div>
                  <div class="guide-match--image">
                    <img src="${getCdnUrl(item.imageUrl)}" width="224" height="140" alt="" role="presentation" />
                  </div>
                </a>
              `;
            },
            noResults() {
              return t("autocomplete.search.top_3_guides");
            },
          },
        },
      ];
    },
  };
}
